export default {
  decode(routes) {
    routes.forEach((route) => {
      route.bounds = this.asBounds(route.bounds);
      route.overview_path = window.google.maps.geometry.encoding.decodePath(
        route.overview_polyline
      );
      route.legs.forEach((leg) => {
        leg.start_location = this.asLatLng(leg.start_location);
        leg.end_location = this.asLatLng(leg.end_location);
        leg.steps.forEach((step) => {
          step.start_location = this.asLatLng(step.start_location);
          step.end_location = this.asLatLng(step.end_location);
          step.path = window.google.maps.geometry.encoding.decodePath(
            step.polyline.points
          );
        });
      });
    });
    return routes;
  },
  asBounds(boundsObject) {
    return new window.google.maps.LatLngBounds(
      this.asLatLng(boundsObject.southwest),
      this.asLatLng(boundsObject.northeast)
    );
  },
  asLatLng(latLngObject) {
    return new window.google.maps.LatLng(latLngObject.lat, latLngObject.lng);
  },
};
